import axios from "axios";


export class Ticker {
  constructor(apikey) {
    this.apikey = apikey;
    this.rates = [];
    this.rate = {};
    this.piPrice = 0;
    //this.fiat = "USD";
  }

  async fetchRate(fiat) {
    try {
      const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/cointicker/${this.apikey}/${fiat}?`);
      //this.rates = response.data.rates;
      this.rate = response.data.rate
      this.piPrice = response.data.piPrice;
      return response.data;
    } catch (error) {
      console.error("Error fetching rates:", error);
      return [];
    }
  }

  /**
   * Fetches the rates of a given fiat currency from the CoinTicker API.
   * @param {string} fiat - The fiat currency to fetch rates for.
   * @returns {Promise<object>} - A promise that resolves with the response data from the CoinTicker API.
   * @throws {Error} - If there is an error fetching the rates.
   */
    async fetchRates() {
    try {
      const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/cointicker/rates/${this.apikey}?`);
      //this.rates = response.data.rates;
      this.rates = response.data.rates
      this.piPrice = response.data.piPrice;
      return response.data;
    } catch (error) {
      console.error("Error fetching rates:", error);
      return [];
    }
  }
    
  getPiRate() {
    if (this.rate) {
      const rate = this.rate.value;
      if (rate) {
        return rate;
      }
    }
    return null;
  }

  getRates() {
    return this.rates;
  }

  getPiPrice() {
    if (this.piPrice && this.piPrice > 0) {
      const parsed = parseFloat(this.piPrice);
      return isNaN(parsed) ? null : parsed;
    }
    return null;
  }

    
  convertCurrentPiValueinProvidedFiat() {

    if (this.getPiPrice() <=-1  && !this.getPiRate()<=-1 ) return null;
    return this.getPiRate() * this.getPiPrice(); // amount in fiat
  }
  
  convertFiattoPi(productAmount) {
    if (this.getPiPrice() <= -1) return null;
    return productAmount / this.convertCurrentPiValueinProvidedFiat()
  ;
  }
  
  convertPitoFiat(productAmount) {
    if (this.getPiPrice() <= 0) return null;
  

    return productAmount * this.convertCurrentPiValueinProvidedFiat()
  ;
  }
}
